import React, {Component} from 'react';
import { connect } from 'react-redux';

import {
  fetchOrderDetail,
  fetchOrderDetailSuccess,
  fetchOrderDetailFailure,
  fetchBackOrderDetail,
  fetchBackOrderDetailSuccess,
  fetchBackOrderDetailFailure,
  clearBackOrderDetail,
} from "../../store/orders/actions";
import { fetchShipment, fetchShipmentSuccess, fetchShipmentFailure } from "../../store/shipments/actions";

import ShipmentDetailHeader from '../../components/shipments/ShipmentDetailHeader';
import ShipmentPackagesList from '../../components/shipments/ShipmentPackagesList';
import ShipmentReturnsList from '../../components/shipments/ShipmentReturnsList';
import Spinner from '../../components/generics/Spinner';

import _ from 'lodash';
import { withRouter } from "utils/WithRouter";

export class ShipmentDetailContainer extends Component {
  componentDidMount(){
    this.props.fetchShipment(this.props.match.params.id);
  }

  componentDidUpdate(prevProps) {
    const shipmentAlreadyLoaded = prevProps.createEditShipment.shipment && prevProps.createEditShipment.shipment.id;
    const shipment = this.props.createEditShipment.shipment;
    // If no shipment was loaded
    if ((!shipmentAlreadyLoaded && shipment && shipment.id) || (
      // Or if it was not the current shipment
      prevProps.createEditShipment.shipment && prevProps.createEditShipment.shipment.id !== shipment.id
    )) {
      if (shipment.market_order) {
        const { order, backOrder } = this.props;
        if (!order.order || order.order.id !== shipment.market_order) {
          this.props.fetchOrder(shipment.market_order);
        }
        if (backOrder.orderId !== shipment.market_order) {
          this.props.fetchBackOrder(shipment.market_order);
        }
      } else {
        this.props.clearBackOrderDetail();
      }
    }
  }

  getReturnedItems = (packages) => {
    let returned = [];
    _.each(packages, (pack)=>{
      _.each(pack.items, (item) => {
        if (item.returned) {
          returned.push(item);
        }
      });
    });
    return returned;
  };

  render() {
    if (this.props.createEditShipment.loading || !this.props.createEditShipment.shipment) {
      return <Spinner />
    } else {
      const returned = this.getReturnedItems(this.props.createEditShipment.shipment.packages);
      const {
        createEditShipment: {
          shipment: {
            market_order: shipmentOrder,
          }
        },
        order,
        backOrder,
      } = this.props;
      return (
        <div>
          <ShipmentDetailHeader
            shipment={this.props.createEditShipment.shipment}
            order={order.loading || !shipmentOrder ? undefined : order.order }
            backOrder={backOrder.loading || !shipmentOrder ? undefined : backOrder.detail}
          />
          <ShipmentPackagesList packages={this.props.createEditShipment.shipment.packages} shipment={this.props.createEditShipment.shipment}/>
          <ShipmentReturnsList returns={returned} />
        </div>
      )
    }
  }
}

// ---------------------------------------------------------------------------
// Redux
// ---------------------------------------------------------------------------
const mapStateToProps = (state, ownProps) => {
  return {
    createEditShipment: state.shipments.createEditShipment,
    order: state.orders.marketOrderDetail,
    backOrder: state.orders.backOrderDetail,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    fetchShipment: (id, props) => {
      dispatch(fetchShipment(id)).payload.then((response) => {
        dispatch(fetchShipmentSuccess(response.data));
      }, (error) => {
        dispatch(fetchShipmentFailure(error));
      });
    },
    fetchOrder: (id) => {
      dispatch(fetchOrderDetail(id)).payload.then((response) => {
        dispatch(fetchOrderDetailSuccess(response.data));
      }, (error) => {
        dispatch(fetchOrderDetailFailure(error));
      });
    },
    fetchBackOrder: (id) => {
      dispatch(fetchBackOrderDetail(id)).payload.then((response) => {
        dispatch(fetchBackOrderDetailSuccess(response.data));
      }, (error) => {
        dispatch(fetchBackOrderDetailFailure(error));
      });
    },
    clearBackOrderDetail: () => {
      dispatch(clearBackOrderDetail());
    }
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(ShipmentDetailContainer));
